module.exports = __webpack_public_path__ + "static/media/preview.27f7a093.png";